import React, { useEffect, useState } from "react";
import Select from "react-select";
import DateTimePicker from "react-datetime-picker";
import { LondonDate, formatDate, validateForm } from "../../Utils/utils";
import ApiService from "../../Core/Service/ApiService";
import { MDBBtn, MDBCheckbox, MDBIcon } from "mdb-react-ui-kit";
import { CmsType, CmsTypeStr } from "../../Constants/constants";
import AdminTable from "../../Components/AdminTable/AdminTable";
import Paginator from "../../Components/Paginator/Paginator";
import LoadingIndicator from "../../Components/LoadingIndicator/LoadingIndicator";
import Moment from "react-moment";
import { useNavigate } from "react-router-dom";
import "./Dashboard.scss";

const ActivityLog = React.memo(props => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const perPageOptions = [
        {value: 10, label: '10'},
        {value: 20, label: '20'},
        {value: 50, label: '50'},
        {value: 100, label: '100'},
    ]
    const [formData, setFormData] = useState({
        pageNum: 1,
        perPage: 10,
        search: {
        },
        sort: {
            name: 'created_at',
            dir: 'DESC'
        }
    });
    const modelOptions = [
        {value: '', label: 'All'},
        {value: CmsType.Top_Ribbon, label: CmsTypeStr[CmsType.Top_Ribbon]},
        {value: CmsType.Home_Banner, label: CmsTypeStr[CmsType.Home_Banner]},
        {value: CmsType.Category_Banner, label: CmsTypeStr[CmsType.Category_Banner]},
        {value: CmsType.Products_Carousel, label: CmsTypeStr[CmsType.Products_Carousel]},
        {value: CmsType.Brochure, label: CmsTypeStr[CmsType.Brochure]},
        {value: CmsType.Bottom_Banner, label: CmsTypeStr[CmsType.Bottom_Banner]},
        {value: CmsType.Brand, label: CmsTypeStr[CmsType.Brand]},
        {value: CmsType.MultiBuy, label: CmsTypeStr[CmsType.MultiBuy]},
    ];
    const actionOptions = [
        {value: '', label: 'All'},
        {value: 'create', label: 'Create'},
        {value: 'update', label: 'Update'},
        {value: 'delete', label: 'Delete'},
    ];
    const [total, setTotal] = useState(0);
    const [rows, setRows] = useState([]);

    const getRows = async () => {
        setLoading(true);

        const data = {
            ...formData,
            search: JSON.stringify(formData.search),
            sort: JSON.stringify(formData.sort)
        }
        
        const response = await ApiService.get('/activity_logs', data);
        
        setTotal(response.data.total);
        setRows(response.data.rows);

        setLoading(false);
    }

    useEffect(() => {
        getRows();
    }, [formData]);

    const onPageChanged = (pageNum) => {
        setFormData({
            ...formData,
            pageNum
        })
    }
    const onPerPageChanged = (opt) => {
        setFormData({
            ...formData,
            pageNum: 1,
            perPage: opt.value
        })
    }

    const gotoDetail = (row) => {
        const action = row.activity_action == 'delete' ? 'view' : 'edit';
        navigate(`/cms/${row.activity_model}/${action}/${row.activity_model_id}`);
    }

    const handleSearch = async (search) => {
        setFormData({
            ...formData,
            pageNum: 1,
            search: search
        })
    }
    const handleSort = (sort) => {
        setFormData({
            ...formData,
            pageNum: 1,
            sort: sort
        })
    }

    const renderTbodyTr = (row, rowIndex) => {
        const now = LondonDate(new Date());
        const start_date = LondonDate(row.start_date);
        const end_date = LondonDate(row.end_date);
        let className = `one-log cursor-pointer ${row.activity_action} `;

        if(row.active == "1") {
            if(end_date < now) className += "expired";
            if(start_date > now) className += "not-started";
            if(start_date < now && now < end_date) className += "active";
        } else {
            className += "inactive";
        }

        return (
            <tr key={rowIndex} className={`${className}`}>
                { columns.map((col, colIndex) => {
                    const el = renderTdCell(row, col.data ?? col.name, rowIndex, colIndex);
                    if(el) {
                        return <td key={colIndex}>{el}</td>
                    } else {
                        return <td key={colIndex}>{row[col.name]}</td>
                    }
                })}
            </tr>
        )
    }

    const renderTdCell = (row, colname, rowIndex, colIndex) => {
        switch(colname) {
            case 'created_at':
                return <div onClick={e=>gotoDetail(row)}>
                    <Moment format="DD/MM/YYYY HH:mm::ss">{LondonDate(row.created_at)}</Moment>
                </div>
            case 'activity_action':
                return <div className="activity-action" onClick={e=>gotoDetail(row)}>{row[colname]}</div>;
            case 'active':
                return <MDBCheckbox defaultChecked={row.active == "1"} />
            case 'action':
                return <div className="d-flex justify-content-end">
                <MDBBtn color="none" tag="a" onClick={() => gotoDetail(row)} title="View Model">
                    <MDBIcon fas icon={row.activity_action == 'delete' ? "eye" : "pencil-alt"} 
                        size="lg" 
                        color={row.activity_action == 'delete' ? "muted" : "primary" }
                    />
                </MDBBtn>
            </div>
            case 'activity_model':
                return <div onClick={e=>gotoDetail(row)}>{CmsTypeStr[row[colname]]}</div>;
            default:
                return <div onClick={e=>gotoDetail(row)}>{row[colname]}</div>;
        }        
    }

    const columns = [
        {name: 'created_at', title: 'Action Time', sortable: true},
        {name: 'activity_action', title: 'Action', sortable: true, search: {
            enable: true, type: 'select', ops:[{value:'=', label: '='}], options:actionOptions
        }},
        {name: 'activity_model', title: 'Model', sortable: true, search: {
            enable: true, type: 'select', ops:[{value:'=', label: '='}], options:modelOptions
        }},
        {name: 'internal_name', title: 'Internal Name', sortable: true, search: {
            enable: true, type: 'text', ops: [{value: 'like', label: 'Like'}]
        }},
        {name: 'start_date', title: 'Start Date', headerStyle:{width:250}, sortable: true, search: {
            enable: true, type: 'date', ops:[{value: '', label: 'All'}, {value: '<', label:'<'}, {value: '>=', label: '>='}]
        }},
        {name: 'end_date', title: 'End Date', headerStyle:{width:250}, sortable: true, search: {
            enable: true, type: 'date', ops:[{value: '', label: 'All'}, {value: '<', label:'<'}, {value: '>=', label: '>='}]
        }},
        {data: 'organization', name: 'epos_organizations.name', title: 'Organization', sortable: true, search: {
            enable: true, type: 'text', ops: [{value: 'like', label: 'Like'}]
        }},
        {name: 'branches', title: 'Branches'},
        {name: 'active', title: 'Active', headerStyle:{width:100}, sortable: true, search: {
            enable: true, type: 'select', ops:[{value:'=', label: '='}], options:[{value: '', label: 'All'}, {value: '1', label: 'Active'}, {value: '0', label: 'Deactive'}]
        }},
        {data: 'editor_name', name: 'epos_managers.username', title: 'Editor', sortable: true, search: {
            enable: true, type: 'text', ops: [{value: 'like', label: 'Like'}]
        }},
        {name: 'action', title: ''}
    ]
    return (
    <div className="activity-log-list">
        <div className="flex-fluid d-flex align-items-center ps-2">
            <label>Per Page:</label>
            <div className="ms-2" style={{width:100}}>
                <Select 
                    options={perPageOptions} 
                    value={perPageOptions.find(opt=>opt.value == formData.perPage)} 
                    onChange={onPerPageChanged}
                />
            </div>
            <label className="ms-4">
                Found 
                <span className='fw-bold mx-2' style={{color: '#333'}}>{total}</span> 
                Matching Results.
            </label>
        </div>

        <div className="mt-3">
            <AdminTable
                columns={columns}
                rows={rows} 
                renderTbodyTr={renderTbodyTr} 
                handleSearch={handleSearch} 
                handleSort={handleSort}
                search={formData.search} 
                sort={formData.sort}
            />
        </div>

        <div className="flex-fluid d-flex justify-content-center mt-4">
            <Paginator curPage={formData.pageNum} total={total} perPage={formData.perPage} onPageChanged={onPageChanged} />
        </div>

        <LoadingIndicator show={loading} />
    </div>
    )
});

export default ActivityLog;